'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _scrollToContent = require('@viskan/scroll-to-content');

var _linkWrapper = require('../../link-wrapper');

var _linkWrapper2 = _interopRequireDefault(_linkWrapper);

var _actions = require('../../utils/actions');

var _createCmsComponent = require('../../utils/create-cms-component');

var _createCmsComponent2 = _interopRequireDefault(_createCmsComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onClick = function onClick(buttonUrl) {
	return function (e) {
		if (buttonUrl.startsWith('#')) {
			e.preventDefault();
			(0, _scrollToContent.scrollToClass)(buttonUrl);
		}
	};
}; /** @jsx dom */


var render = function render(_ref) {
	var props = _ref.props;
	var id = props.id,
	    backgroundColor = props.backgroundColor,
	    borderColor = props.borderColor,
	    borderRadius = props.borderRadius,
	    buttonText = props.buttonText,
	    buttonUrl = props.buttonUrl,
	    fontColor = props.fontColor,
	    fontFamily = props.fontFamily,
	    fontStyle = props.fontStyle,
	    fontWeight = props.fontWeight,
	    iconLayout = props.iconLayout,
	    marginHorizontal = props.marginHorizontal,
	    marginVertical = props.marginVertical,
	    paddingHorizontal = props.paddingHorizontal,
	    paddingVertical = props.paddingVertical,
	    target = props.target;

	var icon = (0, _actions.getIcon)(props);

	var legacyStyles = {
		'margin-top': marginVertical,
		'margin-bottom': marginVertical,
		'margin-left': marginHorizontal,
		'margin-right': marginHorizontal,
		'padding-bottom': paddingVertical,
		'padding-top': paddingVertical,
		'padding-left': paddingHorizontal,
		'padding-right': paddingHorizontal,
		'border-color': borderColor,
		'border-radius': borderRadius,
		'background-color': backgroundColor,
		'color': fontColor,
		'font-family': fontFamily,
		'font-style': fontStyle,
		'font-weight': fontWeight
	};

	return (0, _createCmsComponent2.default)((0, _magicVirtualElement2.default)(
		_linkWrapper2.default,
		{ href: buttonUrl, 'data-id': id, target: target ? '_blank' : '', 'class': ['CMS-Component', props.class, 'Button', props.styleClasses.Button], 'data-style-attr': 'Button', onClick: onClick(buttonUrl), style: !props.styleClasses.Button && legacyStyles },
		icon && iconLayout === 'left' && icon,
		buttonText,
		icon && iconLayout === 'right' && icon
	), props);
};

exports.default = { render: render };